<template>
	<v-menu class="app-dropdown-menu" v-bind="$attrs" v-on="$listeners">
		<template v-slot:activator="{ on, attrs, value }">
			<div v-bind="attrs" v-on="on">
				<slot v-bind:value="value" name="activator" />
			</div>
		</template>
		<v-list v-if="items" dense v-bind="listProps">
			<slot name="list-title" />
			<v-list-item
				v-for="(item, index) in items"
				@click="onItemClick(item)"
				:key="index"
				:disabled="item.divider || item.disabled"
				dense
				v-bind="listItemProps"
			>
				<slot name="divider" v-if="item.divider">
					<div class="width-100 font-size-xs">
						<v-divider />
						<div v-if="item.text">{{ item.text }}</div>
					</div>
				</slot>
				<slot v-bind:index="index" v-bind:item="item" name="list-item" v-else>
					<div class="menu-item py-1">
						<MaybeUpgradeRequiredIndicator :billingFeatureId="item.billingFeatureId" v-if="item.billingFeatureId">
							<template #default="{ indicator, isUpgradeRequired }">
								<AppDropdownMenuItem :item="item" :isUpgradeRequired="isUpgradeRequired" :indicator="indicator" />
							</template>
						</MaybeUpgradeRequiredIndicator>
						<AppDropdownMenuItem v-else :item="item" />
					</div>
				</slot>
			</v-list-item>
			<slot name="list-bottom" />
		</v-list>
	</v-menu>
</template>

<script>
/**
 * Item should look like: item:{text: '', onClick:(), divider: Boolean, }
 */
import AppDropdownMenuItem from './AppDropdownMenuItem.vue';
import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator.vue';
export default {
	name: 'AppDropdownMenu',
	components: {
		MaybeUpgradeRequiredIndicator,
		AppDropdownMenuItem,
	},
	props: {
		items: { type: Array },
		listItemProps: { type: Object },
		listProps: { type: Object },
	},
	methods: {
		onItemClick(item) {
			item.onClick?.();
		},
	},
};
</script>

<style scoped lang="scss">
.app-dropdown-menu {
	&::before {
		content: none !important;
	}
}
.menu-item {
	font-size: 14px;
	font-weight: normal;
	color: var(--primary-font-color);
}

.menu_btn {
	border-radius: 1px;

	&::before {
		content: none !important;
	}
}

.v-menu__content {
	.v-divider {
		margin: 3px 0;
	}
}
</style>
